import Vue from 'vue';
import directive from './directive';
import filter from './filter';
import globalComponents from './globalComponents';

export default function() {
  const plugins = [directive, filter, globalComponents];

  plugins.forEach(pluginItem => Vue.use(pluginItem));
}
